import React from 'react';
import { Divider } from '@mui/material';
import {
  AI_COLORS, AI_FONTS,
  PageHero, ContentWrap, SectionTitle,
  LightboxImage,
} from '../shared';

import img54 from '../../../imgs/adulto-idosos/54.png';

const urgencias = [
  'Dores de origem dental',
  'Infecções odontogênicas',
  'Traumas dentais e faciais',
  'Hemorragias por trauma ou pós-cirúrgicas',
];

export default function Atendimento() {
  return (
    <div style={{ fontFamily: AI_FONTS.body, background: 'transparent' }}>
      <PageHero
        title="Como ser atendido(a)?"
        subtitle="Saiba como acessar o atendimento odontológico do HOUFU pelo SUS e onde procurar ajuda em casos de urgência."
      />

      <ContentWrap>
        <SectionTitle style={{ marginTop: 0 }}>Como ser atendido(a)?</SectionTitle>
        <p style={{ lineHeight: 1.8 }}>
          Para ser atendido(a) no HOUFU, é necessário comparecer à <strong>Unidade Básica de Saúde
          (UBS)</strong> mais próxima do seu bairro. Lá, a equipe irá avaliar a sua situação e
          verificar a possibilidade de encaminhamento para atendimento nas clínicas odontológicas da
          faculdade.
        </p>
        <p style={{ lineHeight: 1.8 }}>
          O HOUFU desenvolve atividades clínicas vinculadas à Faculdade de Odontologia, em parceria
          com o Hospital Odontológico, e presta atendimentos à comunidade fazendo parte da{' '}
          <strong>Rede de Atenção à Saúde Bucal (RASB)</strong> do município de Uberlândia por meio
          do <strong>Sistema Único de Saúde (SUS)</strong>.
        </p>
        <p style={{ lineHeight: 1.8 }}>
          Além dos atendimentos básicos em odontologia (limpezas, restaurações, extrações dentárias
          e outros), o HOUFU é um <strong>centro de referência regional</strong> para procedimentos
          especializados (próteses, tratamento de canal e outros).
        </p>

        <Divider style={{ margin: '32px 0', borderColor: AI_COLORS.bgBlue100 }} />

        <SectionTitle style={{ marginTop: 0 }}>Em casos de urgência e emergência</SectionTitle>
        <p style={{ lineHeight: 1.8 }}>
          Em casos de urgência e emergência, como:
        </p>
        <ul style={{ paddingLeft: 20, lineHeight: 2 }}>
          {urgencias.map((u, i) => (
            <li key={i}>{u}</li>
          ))}
          <li>Entre outras</li>
        </ul>

        <div
          style={{
            background: AI_COLORS.bgAmber50,
            borderLeft: `4px solid ${AI_COLORS.amber300}`,
            borderRadius: 10,
            padding: '18px 22px',
            marginTop: 16,
          }}
        >
          <p style={{ margin: 0, lineHeight: 1.8 }}>
            Você pode procurar serviços odontológicos no{' '}
            <strong>Pronto Socorro Odontológico (PSO)</strong>, que se encontra dentro do{' '}
            <strong>Hospital de Clínicas da Universidade Federal de Uberlândia</strong>, sem
            necessidade de agendamento prévio. O PSO funciona <strong>24 horas, todos os dias da
            semana</strong>.
          </p>
        </div>

        <LightboxImage src={img54} alt="Fluxograma do Atendimento" caption="Fluxograma do Atendimento (clique para ampliar)" />
      </ContentWrap>
    </div>
  );
}
